SlideView              = require("views/slide")
{ Analytics, Session } = Application.actions()

class InputView extends SlideView
  nextSlide: ->
    Session.get (err, { attempt }) =>
      Backbone.Events.trigger('event:survey-complete', { slide_id: @options.id, user_input: @userInput(), attempt })
    @submit()

module.exports = InputView
